interface BodyLocationSkinProps {
  className?: string;
  pathClassName?: string;
}

export function BodyLocationSkin({ className, pathClassName }: BodyLocationSkinProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M40.0607 9.34177L33.9022 8.16843C32.3461 7.87184 31.2166 6.50684 31.2166 4.92245V2.37729C31.2166 1.06635 30.1501 0 28.8395 0H19.1609C17.8501 0 16.7837 1.06651 16.7837 2.37729V4.92245C16.7837 6.50668 15.6543 7.87168 14.0983 8.16843L7.93956 9.34177C4.09455 10.0746 1.41893 13.5702 1.71583 17.4733L3.87104 45.8033C3.96504 47.0351 5.00619 47.9998 6.24152 47.9998H41.7589C42.9945 47.9998 44.0355 47.0348 44.1292 45.8031L46.2845 17.4733C46.5813 13.5702 43.9058 10.0746 40.0607 9.34177ZM43.9134 17.2929L41.7587 45.6222H36.5638L35.4156 40.129L39.422 22.6023C39.5683 21.9623 39.1679 21.3246 38.5278 21.1785C37.8877 21.0317 37.2501 21.4326 37.104 22.0727L33.0396 39.8528C33.0014 40.0199 32.9998 40.1932 33.0348 40.3609L34.1345 45.6224L13.8654 45.6227L14.9651 40.3609C15.0001 40.1932 14.9985 40.0199 14.9603 39.8528L10.8959 22.0727C10.7496 21.4326 10.1127 21.032 9.47211 21.1785C8.83201 21.3248 8.43176 21.9623 8.57791 22.6023L12.5843 40.129L11.4361 45.6226H6.24183L4.08678 17.2929C3.88166 14.5976 5.72934 12.1837 8.38452 11.6774L14.5433 10.504C17.2192 9.99392 19.1615 7.64658 19.1615 4.92245L19.1609 2.37777L28.8389 2.37729V4.92245C28.8389 7.64674 30.7812 9.99392 33.4573 10.504L39.6157 11.6774C42.2709 12.1835 44.1186 14.5976 43.9134 17.2929Z"
        fill="var(--gray-300)"
        className={pathClassName}
      />
      <path
        d="M24.0001 14.1813C23.4749 14.1813 23.049 14.6073 23.049 15.1324V35.731C23.049 36.2562 23.4749 36.6821 24.0001 36.6821C24.5252 36.6821 24.9512 36.2562 24.9512 35.731V15.1324C24.9512 14.6071 24.5254 14.1813 24.0001 14.1813Z"
        fill="var(--gray-300)"
        className={pathClassName}
      />
    </svg>
  );
}
